package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

data class ModalDateState(
    val title: String = "",
    val show: Boolean = false,
    val questionId: String = "",
    val dateIso: String = ""
)
